import { createFileRoute } from '@tanstack/react-router';
import { LaborInsuranceDeclarationProfileRegistryPage } from './-components/LaborInsuranceDeclarationProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/labor-insurance-declarations/')({
  component: LaborInsuranceDeclarationProfileRegistryPage
});